const exactCookieNames = new Set([
    "_ga",
    "_gid",
    "_gat",
    "_pin_unauth",
    "hubspotutk",
    "__hstc",
    "__hssc",
    "__hssrc",
    "messagesUtk",
    "li_fat_id"
]);

const cookieNamePrefixes = ["_ga_", "_gat_", "_gac_", "_gcl_", "_li_id", "_li_ses"];

export function isKnownAnalyticsCookie(cookieName: string): boolean {
    return exactCookieNames.has(cookieName) || cookieNamePrefixes.some(prefix => cookieName.startsWith(prefix));
}

export function analyticsCookieExpiryHeaders(cookieHeader: string, hostname: string): string[] {
    const cookieNames = cookieHeader
        .split(";")
        .map(cookie => cookie.split("=", 1)[0].trim())
        .filter(cookieName => cookieName.length > 0 && isKnownAnalyticsCookie(cookieName));
    const parentDomain = hostname === "smartguide.app" || hostname.endsWith(".smartguide.app")
        ? ".smartguide.app"
        : null;

    return cookieNames.flatMap(cookieName => {
        const hostExpiry = `${cookieName}=; Max-Age=0; Path=/; SameSite=Lax`;
        return parentDomain
            ? [hostExpiry, `${hostExpiry}; Domain=${parentDomain}`]
            : [hostExpiry];
    });
}

export function clearKnownAnalyticsCookies(documentRef: Document, hostname: string): void {
    for (const expiryHeader of analyticsCookieExpiryHeaders(documentRef.cookie, hostname)) {
        documentRef.cookie = expiryHeader;
    }
}
